<template>
  <div>
    <p>Loyalty Program Menu</p>
    <a-button @click="navigate('EditCard')">
      <span v-if="loyaltyData.id">Edit Loyalty Card Details</span>
      <span v-else>Create Loyalty Card</span>
    </a-button>
    <br><br>
    <a-button v-if="loyaltyData.id" @click="navigate('ManageCard')">Manage Settings and QR Codes</a-button>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'
import {API_URL} from '../../constants'
export default {
  name: 'Loyalty',
  data () {
    return {
      message: '',
      moment,
      API_URL,
    }
  },
  mounted () {
    this.$store.dispatch('loyalty/getLoyaltyData')
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
    },
    navigate (name) {
      this.$router.push({name})
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      loyaltyData: state => state.loyalty.loyaltyProgram,
    }),
  },
}
</script>

<style lang="scss">
  @import "./../../assets/styles";
  .title-on-dashboard{
    background: #FFF;
    margin-top: -10px;
    width: max-content;
    padding: 0 10px;
    margin-left: 10px;
  }
  .logout-btn {
    margin: 16px auto;
    display: flex;
  }
  .my-main-row .ant-col-7,  .my-main-row .ant-col-24 {
    height: 250px;
    border: 1px solid #000000;
    display: flex;
    justify-content: center;
  }
  .my-main-row {
    margin: 16px 0;
  }
  .activity-row{
    border: 1px solid black;
    width: 100%;
  }
  .grid-container {
    display: grid;
    height: 80px;
    grid-template-columns: 200px 1fr;
    margin: 20px;
  }
  .client-logo{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .order-main {
    display: grid;
    align-items: center;
    grid-template-rows: 1fr 1fr;
  }
  .order-main p{
    display: flex;
    align-items: center;
    margin: 0;
  }
  .counter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: baseline;
    height: 100%;
    font-size: 135px;
  }
  .centerTitle {
    width: 100%;
    justify-content: center;
    display: flex;
    margin-top: 20px;
    font-size:22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loyalty/Loyalty.vue